var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quick-navigation"},[_c('router-link',{staticClass:"quick-navigation-option",attrs:{"to":{name: 'folder_creatives', params: {campaign_id: _vm.folder.campaign_id, folder_id: _vm.folder.folder_id}}}},[_c('i',{staticClass:"nexd-icon-32-notification-list",attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v("Open")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }